// Adapted from davinci-elections apps/web/src/theme/recipes/index.ts @ 6e23f58
import { defineRecipe, type RecipeDefinition, type SlotRecipeDefinition } from '@chakra-ui/react'
import { Badge } from './badge'
import { Button } from './button'
import { Card } from './card'
import { checkbox } from './checkbox'
import { Drawer } from './drawer'
import { fieldRecipe, formLabel, input, nativeSelect, switchRecipe, textarea } from './form'
import { listSlotRecipe } from './list'
import { Menu } from './menu'
import { Popover } from './popover'
import { Progress } from './progress'
import { Stepper } from './stepper'
import { Table } from './table'
import { Tabs } from './tabs'
import { Tag } from './tag'
import { Tooltip } from './tooltip'
import { heading, link, text } from './typography'

// Mirrors vocdoni-app src/theme/recipes/index.ts (generic recipes only; the vocdoni-app election /
// organization / pricing recipes are not needed here).
export const recipes: Record<string, RecipeDefinition> = {
  badge: Badge,
  button: Button,
  formLabel,
  heading,
  input,
  link,
  text,
  icon: defineRecipe({
    base: {
      boxSize: 4,
    },
  }),
  textarea,
}

export const slotRecipes: Record<string, SlotRecipeDefinition> = {
  card: Card,
  checkbox,
  drawer: Drawer,
  field: fieldRecipe,
  nativeSelect,
  list: listSlotRecipe,
  menu: Menu,
  popover: Popover,
  progress: Progress,
  switch: switchRecipe,
  table: Table,
  tabs: Tabs,
  tag: Tag,
  tooltip: Tooltip,
  steps: Stepper,
}
